import { useContext } from "react";
import AuthContext from "../Context/AuthProviders";

const useAuth = () => useContext(AuthContext);

export default useAuth;